module.exports = __webpack_public_path__ + "img/9 filters-03.33df253d.png";